export default "__VITE_ASSET__8662a8d0__"